module.exports = __webpack_public_path__ + "static/YT-5c5cfac140835f3cd4cfce4baa1d37ce.mp4";